export {default} from './CommentCard.container';
